<template>
    <div class="logger" ref="logger" v-html="logData">
    </div>
    <!-- <a-textarea ref="textarea" v-model="logData" disabled placeholder="" :rows="10" /> -->
</template>

<script>
import eventBus from '../eventBus';

export default {

  created() {
    eventBus.$on('new-log-line',this.addLogData)
    eventBus.$on('new-log-error',this.addErrorLog)
    eventBus.$on('new-log-end',this.endHandler)

  },

  beforeDestroy() {
    eventBus.$off('new-log-line',this.addLogData)
    eventBus.$off('new-log-error',this.addErrorLog)
    eventBus.$off('new-log-end',this.endHandler)
  },

  data() {
    return {
      logData:""
    }
  },

  methods: {
    endHandler(data){
      this.$emit('end',data)
      this.refreshHeight()
    },
    refreshHeight(){
      this.$nextTick(()=>{
        this.$refs.logger.scrollTop = this.$refs.logger.scrollHeight;
      })
    },
    addErrorLog(data){
      data = data.replace(/\n/gi,'<br/>')
      this.logData += `<p class="error">${data}</p>`;
      this.refreshHeight()
    },
    addLogData(data){
      data = data.replace(/\n/gi,'<br/>')
      this.logData += `<p>${data}</p>`;
      this.refreshHeight()
    }
  },
}
</script>
<style lang="scss">
  .logger{
    flex-grow: 1;
    overflow: auto;
    p{
      margin: 0;
      font-family: monospace;
      font-size: 14px;

      &.error{
        color: darkred;
      }
    }
  }
</style>